export type InputProps = {
  className?: string;
  disabled?: boolean;
  label?: string;
  onChange?: (value: string) => void;
  placeholder?: string;
  value: string;
}

const Input = ({ className, disabled = false, label, onChange, value, placeholder }: InputProps): JSX.Element => {
  return  <label className={`flex flex-col text-caption gap-1v ${className}`}>
            {label}
            <input  className='m-0 px-2w py-1w border rounded text-body1 disabled:outline-none disabled:bg-grey-100'
                    disabled={disabled}
                    onChange={(event) => onChange(event.target.value)}
                    type='text'
                    placeholder={placeholder}
                    value={value} />
          </label>
}

export default Input;